import {createApp} from 'vue'
import router from "./router"
import '@/assets/style.css'
import '@/assets/root.css'
import App from './App.vue'
import {createPinia} from 'pinia'
import CountryFlag from 'vue-country-flag-next'
import {vValidation} from '@/shared/components/ui/form2/formValidation.ts'
import {initSentry} from "@/shared/lib/sentry.ts";
import {useCheckoutStore} from "@/checkout/stores/checkout.store.ts";
import {initializeI18n, Locale} from "@/checkout/i18n/i18n.ts";
import * as Sentry from "@sentry/vue";
import {registerGlobalErrorListener} from "@/shared/lib/deploy";
import piniaSentry from "@/shared/plugins/pinia-sentry.ts";

registerGlobalErrorListener(__SENTRY_RELEASE__, __SENTRY_ENVIRONMENT__).then(() => console.log("Global listener registered"));

const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaSentry);

app.use(pinia);
app.use(router)
app.use(CountryFlag);
app.directive('validation', vValidation)
if (import.meta.env.MODE !== 'development') {
    initSentry({
        release: __SENTRY_RELEASE__,
        environment: __SENTRY_ENVIRONMENT__,
        dsn: "https://069beafc414f64eeaf16ea8211034f74@o4505918764613632.ingest.us.sentry.io/4508613276663808",
        app: app,
        router: router,
    }, true)
}
try {
    const supportedLocales = [new Locale('nl', 'BE'), new Locale('en', 'US'), new Locale('fr', 'FR'), new Locale('de', 'DE')]
    const path = window.location.pathname;
    const regex = /^\/(?:checkout\/)?([^/]+)(?:\/complete)?\/?$/;
    const match = path.match(regex);

    if (match && path !== "/checkout/guest-starter") {
        const checkoutId = match[1];
        const checkout = useCheckoutStore();
        checkout.init(checkoutId.toString()).then(() => {
            const initLocale = checkout.locale || new Locale('nl', 'BE')
            initializeI18n(initLocale, supportedLocales).then(async (i18n) => {
                app.use(i18n);
                app.mount('#app')
            })
            setSentryUser()
        })
    } else {
        const initLocale = new Locale('nl', 'BE')
        initializeI18n(initLocale, supportedLocales).then(async (i18n) => {
            app.use(i18n);
            app.mount('#app')
        })
    }
} catch (e) {
    Sentry.captureException(e, {
        extra: {
            location: "Could not initialize checkout",
        }
    });
}

function setSentryUser() {
    //Set the sentry user if we know the customer name
    try {
        const checkout = useCheckoutStore();
        const sentryUser = {username: checkout.username};
        Sentry.setUser(sentryUser);
    } catch (e) {
        console.error("could not set Sentry User", e)
    }
}